import { cloneDeep } from "lodash";
import { Risk } from "./types/types";

export const EMPTY_CLAIMS_FREE_EXPERIENCE = {
    type_of: null,
    insurer: null,
    country: null,
    no_claims_discount_years: null,
    relationship_to_proposer: null,
    policy_number: null,
    expiry_date: null
};

export const EMPTY_PREVIOUS_POLICY = {
    insurer: null,
    no_claims_discount_years: null,
    has_claims: null,
    claims: []
};

export const EMPTY_ADDITIONAL_COVER = {
    accidental_damage_cover: null,
    unspecified_item_cover: null,
    specificed_item_cover: null,
    items: []
};

export const EMPTY_RISK: Risk = {
    policy_details: {
        start_date: null,
        property_type: null
    },
    cover_details: {
        buildings_cover_amount: null,
        contents_cover_amount: null,
        voluntary_excess: 0,
        additional_cover: cloneDeep(EMPTY_ADDITIONAL_COVER),
        has_specified_items: null,
        specified_items: [],
        unspecified_risk_amount: null,
        has_sports_equipment: false,
        sports_equipment_amount: null
    },
    proposer: {
        personal_details: {
            title: null,
            first_name: null,
            surname: null,
            date_of_birth: null
        },
        address: {
            address_line1: null,
            address_line2: null,
            address_line3: null,
            address_line4: null,
            ecad_id: null,
            eircode: null
        },
        email: null,
        mobile_phone_number: null,
        employment_details: {
            occupation: null
        },
        previous_policy_details: cloneDeep(EMPTY_PREVIOUS_POLICY)
    },
    property_details: {
        type: null,
        year_built: null,
        number_of_bathrooms: null,
        number_of_bedrooms: null,
        heating_system: null,
        building_energy_rating: null,
        address: {
            address_line1: null,
            address_line2: null,
            address_line3: null,
            address_line4: null,
            ecad_id: null,
            eircode: null
        },
        security_details: {
            alarm_type: null,
            has_locks_on_all_doors_windows: null
        },
        has_buildings_contents_accidental_damage: null,
        has_different_correspondence_address: null
    },
    residency_details: {
        is_occupied_during_day: null,
        is_landlord: null,
        number_of_paying_guests: null,
        residence_ownership_status: null,
        residence_holiday_home_type: null,
        residence_no_of_tenants: null,
        residence_rental_status: null
    },
    has_joint_proposers: false,
    joint_proposers: [],
    has_interested_parties: false,
    interested_parties: []
};
